import classNames from 'classnames'
import React from 'react'
import PropTypes from 'prop-types'
import elementType from 'prop-types-extra/lib/elementType'
import './Col.sass'
import { bsClass, prefix, splitBsProps } from '../../utils'
import { DEVICE_SIZES } from '../../utils/StyleConfig'

{/* eslint-disable */}
const propTypes = {
  componentClass: elementType,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number
}
{/* eslint-disable */}
const defaultProps = {
  componentClass: 'div',
  xs: 6,
  sm: 12,
  md: 24,
  lg: 24
}

class Col extends React.PureComponent {
  render() {
    const { componentClass: Component, className, ...props } = this.props
    const [bsProps, elementProps] = splitBsProps(props)

    const classes = []

    DEVICE_SIZES.forEach(size => {
      function popProp(propSuffix, modifier) {
        const propName = `${size}${propSuffix}`
        const propValue = elementProps[propName]

        if (propValue != null) {
          classes.push(prefix(bsProps, `${size}${modifier}-${propValue}`))
        }

        delete elementProps[propName]
      }

      popProp('', '')
      popProp('Offset', '-offset')
      popProp('Push', '-push')
      popProp('Pull', '-pull')

      const hiddenPropName = `${size}Hidden`
      if (elementProps[hiddenPropName]) {
        classes.push(`hidden-${size}`)
      }
      delete elementProps[hiddenPropName]
    })

    return (
      <Component {...elementProps} className={classNames(className, classes)} />
    )
  }
}

Col.propTypes = propTypes
Col.defaultProps = defaultProps

export default bsClass('col', Col)



// WEBPACK FOOTER //
// ./components/Col/index.jsx